import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const CloseButton = styled('div')`
  display: inline-flex;
  margin-left: auto;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background: #ddebfa;
    svg {
      color: ${colorTokens.text.hover};
    }
  }
`;
